import { createFileRoute } from "@tanstack/react-router";
import BcbsIllinoisSaint from "@/pages/BcbsIllinoisSaint";
export const Route = createFileRoute("/bcbs-illinois-saint")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "BCBS Illinois SAINT® TMS | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "BCBS Illinois members: SAINT® TMS for depression at Neuro Wellness in Coral Springs, FL. Verify benefits and start your 5-day treatment course.",
        },
        {
          property: "og:title",
          content: "BCBS Illinois SAINT® TMS | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "BCBS Illinois members: SAINT® TMS for depression at Neuro Wellness in Coral Springs, FL. Verify benefits and start your 5-day treatment course.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/bcbs-illinois-saint",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/bcbs-illinois-saint",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <BcbsIllinoisSaint />;
}
